import Vue from 'vue';
import BzbsApi from '@/core/Http/BzbsApi.js';

export default {
    // apiGiftInfo: function (redeemKey) {
    //     var strUrl = `${Vue.bzbsConfig.bzbsUrl}/gift/${redeemKey}`;
    //     return new Promise((resolve, reject) => {
    //         BzbsApi.connectBzbsGet(strUrl).then((response) => {
    //             resolve(response);
    //         }).catch((error) => {
    //             reject(error);
    //         });
    //     });
    // }
    config: function () {
        return Vue.bzbsConfig;
    },
    apiGiftInfo: function (redeemKey) {
        let url = this.config().bzbsUrl + '/gift/' + redeemKey
        return BzbsApi.connectBzbsGet(url, null, null);
    },
}
